import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'

const ListItems = ({ listItems, nested }) => {
  const depth = nested || 0

  const ListItem = styled.li`
    align-items: center;
    list-style: none;
    font-size: 13px;
    position: relative;
    margin-right: 10px;
    border-left: 0px solid transparent;
    font-family: 'fira sans', sans-serif;
    line-height: 14px;
  `

  const list = listItems.map(({ url, title, items }) => {
    return (
      <ListItem key={url}>
        <a
          css={css`
            color: rgb(68, 68, 68) !important;
            text-decoration: none !important;
            padding: 10px 0px 10px 19px;
            display: block;
            border-radius: 4px;
            transition: 0.3s;
            font-weight: bold;
            line-height: 18px;
            &:focus {
              outline-width: 3px;
            }
            &:hover {
              background: white;
            }
            &:visited {
              color: rgb(68, 68, 68) !important;
            }
          `}
          href={url}
        >
          {title}
        </a>
        {items && depth <= 0 && (
          <ul
            css={css`
              padding: 0;
              border-left: none;
              margin: 0px 0px 0px 15px;
            `}
            nested={depth}
          >
            {/* To iterate is human; to recurse, divine */}
            <ListItems nested={depth + 1} listItems={items} />
          </ul>
        )}
      </ListItem>
    )
  })

  return list
}

const Aside = ({ tableOfContents }) => {
  const listItems = tableOfContents.items[0].items

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        width: 275px;
        max-height: calc(100vh - 64px);
        overflow-y: auto;
        margin-top: 20px;
        margin-left: auto;
        padding: 40px 40px;
        padding-right: 0;
        position: sticky;
        top: 64px;
        margin-right: 15px;
        @media (max-width: 1100px) {
          display: none;
        }
      `}
    >
      <h4
        css={css`
          font-family: 'Alternate Gothic', 'Franklin Gothic Medium',
            'Arial Narrow', sans-serif;
          -webkit-font-smoothing: antialiased;
          color: white;
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 0;
          padding: 10px 20px;
          line-height: 1.1;
          font-weight: normal;
          background: #284fff;
          margin-top: 0;
          margin-bottom: 0;
        `}
      >
        On This Page
      </h4>
      <ul
        css={css`
          padding: 0;
          border-left: none;
          margin: 1em 0 67px 0;
          background: #f5f6f7;
          margin-top: 0px;
        `}
      >
        <ListItems listItems={listItems} />
      </ul>
    </div>
  )
}

export default Aside
